import getSearchPrefix from '~/utils/getSearchPrefix';
import { normalizeSearchString } from '~/utils/normalizeSearchString';
import { SEARCH_PAGE_PREFIXES } from '#shared/constants';
import addQueryParam from '~/utils/addQueryParam';

export default function useSearchUrl() {
  const { isMcom } = useEnvProps();

  const buildSearchUrl = (label) => {
    const urlPrefix = getSearchPrefix();
    const normalizedLabel = normalizeSearchString(label, urlPrefix === SEARCH_PAGE_PREFIXES.featured);
    const normalizedSearchValue = normalizeSearchString(label, false);

    const queryParams = {
      cm_kws_ls: isMcom ? normalizedSearchValue : '',
      ss: true,
    };

    return addQueryParam(`${urlPrefix}${normalizedLabel}`, queryParams);
  };

  return {
    buildSearchUrl,
  };
}
